const stringNormalize = require('string-normalize-es6');

export const formatUrl = (val) => {
    if (val === undefined) {
        return;
    }
    if (val.length > 1) {
        const custom_url = stringNormalize(val).replace(/([^a-z0-9/\s\-])+/gi, '').replace(/[\s\-]+/g, '-');
        return custom_url.toLowerCase();
    }
};


const FRENCH_DATE_FORMAT = new Intl.DateTimeFormat("fr-FR", {
    timeZone: "Europe/Paris",
    day: "2-digit",
    month: "long",
    year: "numeric",
});

export const convertDate = (date) => {
    return FRENCH_DATE_FORMAT.format(new Date(date));
};


// Percentage for CardItem Progress bar
export const calculPercentage = (collected, totalPrice) => {
    return Math.floor((collected / totalPrice) * 100);
};

export const getProductTargetAmount = (product) => {
    if (!product) {
        return 0;
    }
    const price = product.price || 0;
    return product.quantity ? price * product.quantity : price;
};

export const getProductCollectedAmount = (product) => {
    if (!product) {
        return 0;
    }
    return product.collected_amount_on_pot || product.amount_collected || 0;
};

export const getProductRemainingAmount = (product) => {
    return Math.max(0, getProductTargetAmount(product) - getProductCollectedAmount(product));
};
